import { lazy } from 'react';

export default {
  VersionList: lazy(() => import('./mapping/VersionList')),
  PaymentList: lazy(() => import('./mapping/PaymentList')),
  LogErrorList: lazy(() => import('./mapping/LogErrorList')),
  ReceiptList: lazy(() => import('./mapping/ReceiptList')),
  GiftList: lazy(() => import('./mapping/GiftList')),
};
